@if (model()?.batch?.expandable) {
<div class="batch-node">
    <div class="node-bar">
        <div class="node-nav" (click)="onToggle()">
            @if (model()?.children && model()?.batch?.expanded) {
            <mat-icon>expand_more</mat-icon>
            }
            @if (model()?.children && !model()?.batch?.expanded) {
            <mat-icon>chevron_right</mat-icon>
            }
        </div>
        <div class="node-nav">
            <mat-icon>{{icon}}</mat-icon>
        </div>
        <div class="node-info" tabindex="-1"
            [ngClass]="{'no-chevron': !model()?.children, 'active': $safeNavigationMigration(model()?.batch?.active)}">
            <div class="node-name">
                {{model()?.node?.name}}
            </div>
            @if (model()?.site !== model()?.node && model()?.parent && $any(model()!.node)?.prototypeId) {
            <input type="checkbox" [disabled]="model()!.batch!.disabled" class="check"
                [ngModel]="model()?.batch?.checked" (ngModelChange)="onModel($event)" (change)="onChange($event)" />
            }
        </div>
    </div>
    <ul [hidden]="!model()?.batch?.expanded || !model()?.batch?.expandable">
        @for (descent of model()?.descents; track descent.node._id) {
        <li>
            @if (descent.children) {
            <app-batch-node [model]="descent"></app-batch-node>
            }
        </li>
        }
    </ul>
</div>
}
